import {
  jb_feature_list_css_default
} from "./chunk.WR7LWUF7.js";
import {
  Spaceable
} from "./chunk.MFPI4EPN.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-feature-list/jb-feature-list.ts
var JbFeatureList = class extends Initiable(Spaceable(r)) {
  render() {
    return ke`
      <div>
        <ul>
          ${this.features.map(
      (feature) => ke` <li>
                <jb-checkmark-icon></jb-checkmark-icon>
                ${feature}
              </li>`
    )}
        </ul>
      </div>
    `;
  }
};
JbFeatureList.styles = [reset_css_default, jb_feature_list_css_default];
__decorateClass([
  n({ type: Array })
], JbFeatureList.prototype, "features", 2);
JbFeatureList = __decorateClass([
  customElement("jb-feature-list")
], JbFeatureList);

export {
  JbFeatureList
};
